<template>
    <v-card >
  
          <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Ménages
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
    <v-card-text>
       <v-list>
        <v-list-item
          v-for="(item, index) in Menages"
          :key="index"
          class="project"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.nomMembrePrincipal"></v-list-item-title>
            <v-list-item-title v-html="item.ll_region"></v-list-item-title> 
            <v-list-item-title v-html="item.ll_district"></v-list-item-title>
            <v-list-item-title v-html="item.ll_commune"></v-list-item-title> 
            <v-list-item-title v-html="item.ll_fokontany"></v-list-item-title> 
            <v-list-item-title v-html="item.projets[0].ll_programme"></v-list-item-title>            
          </v-list-item-content>

         <!--  <v-list-item-icon>
            <v-btn icon @click="addProjet(item)">
              <v-icon>add_circle</v-icon>
            </v-btn>

            <v-btn icon @click="deleteBailleur(item)">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn icon @click="openDialog(item)">
              <v-icon>edit</v-icon>
            </v-btn>

            <v-btn icon @click="detailsBailleur(item)">
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-list-item-icon> -->
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <div class="text-center">
        <v-btn
          class="primary"
          @click="prevPage()"
          :disabled="disable_prev || !(pagination_clicked_count > 0)"
          >Précédent</v-btn
        >
        <v-btn class="mx-3" fab color="primary">{{
          pagination_clicked_count + 1
        }}</v-btn>
        <v-btn class="primary" @click="nextPage" :disabled="disable_next"
          >Suivant</v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {    
    this.GetMenages();
  },
  computed: {
    ...mapState({
      Menages: (state) => state.Menages.Menages,
      pagination_clicked_count: (state) => state.Menages.pagination_clicked_count,
      disable_next: (state) => state.Menages.disable_next,
      disable_prev: (state) => state.Menages.disable_prev,
    }),
  },
  methods: { 
    ...mapActions({
      GetMenages: "Menages/Get",
      prevPage: "Menages/prevPage",
      nextPage: "Menages/nextPage",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
